// left side is vertical, and bottom side is horizontal  

// defines position of the verticesdakafwerking =
function positionBuffer (totaleBreedte, plankHoogte, dikte, degrees) {
  const radians = degrees * (Math.PI/180);
  const r1 = (90 - degrees) * (Math.PI/180);

  const x = totaleBreedte
  const z = dikte / 2
  const h = totaleBreedte*Math.tan(radians)
  const i = plankHoogte/(Math.sin(r1))
  const j = plankHoogte*Math.sin(radians)
  const k = Math.sqrt((plankHoogte**2)-(j**2))

  // h   ->   0
  // h-i   ->   -i
  // 0   ->   -h
  // -k   ->   -h-k

  // x   ->   0
  // 0   ->   -x
  // j   ->   -x+j


  return [
    0, 0, z, 
    0, 0, -z, 
    0, -i, z, 
    0, -i, -z, 
    -x, -h, -z, 
    -x, -h, z, 
    -x+j, -h-k, -z, // j/0   -k/-y
    -x+j, -h-k, z, // j/0   -k/-y
    -x, -h, -z, 
    0, 0, -z,
    -x, -h, z, 
    0, 0, z,
    -x+j, -h-k, z, /// j/0   -k/-y
    0, -i, z, 
    -x+j, -h-k, -z, // j/0   -k/-y
    0, -i, -z, 
    -x, -h, z, 
    0, 0, z,
    -x+j, -h-k, z, // j/0   -k/-y
    0, -i, z, 
    0, 0, -z,
    -x, -h, -z, 
    0, -i, -z, 
    -x+j, -h-k, -z // j/0   -k/-y
  ]
}

// defines position of the textures
function uvBuffer (totaleBreedte, plankHoogte, dikte, degrees, maxTextureWith, maxTextureHeight) { 
  //return [0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0]
  //return [0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0]
  const radians = degrees * (Math.PI/180);
  const r1 = (90 - degrees) * (Math.PI/180);

  const h = totaleBreedte*Math.tan(radians)
  const i = plankHoogte/(Math.sin(r1))
  const j = plankHoogte*Math.sin(radians)
  const k = Math.sqrt((plankHoogte**2)-(j**2))

  const tw = maxTextureWith || 2320
  const th = maxTextureHeight || 145

  return [
    0, i/th, 
    dikte/tw, i/th, 
    0, 0, 
    dikte/tw, 0,

    0.2, plankHoogte/th, 
    ((dikte/tw )+0.2), plankHoogte/th,
    0.2, 0, 
    ((dikte/tw )+0.2), 0,

    0.7, dikte/th, 
    ((Math.sqrt((totaleBreedte**2)+(h**2))/tw )+0.7), dikte/th, 
    0.7, 0, 
    ((Math.sqrt((totaleBreedte**2)+(h**2))/tw )+0.7), 0,

    0.3, dikte/th, 
    ((Math.sqrt(((totaleBreedte-j)**2)+((h-i+k)**2))/tw )+0.3), dikte/th, 
    0.3, 0, 
    ((Math.sqrt(((totaleBreedte-j)**2)+((h-i+k)**2))/tw )+0.3), 0,

    0.5, plankHoogte/th,
    ((Math.sqrt((totaleBreedte**2)+(h**2))/tw )+0.5), plankHoogte/th,
    0.5, 0, 
    ((Math.sqrt(((totaleBreedte-j)**2)+((h-i+k)**2))/tw )+0.5), 0,

    Math.sqrt((totaleBreedte**2)+(h**2))/tw, plankHoogte/th,
    0, plankHoogte/th,
    Math.sqrt(((totaleBreedte-j)**2)+((h-i+k)**2))/tw, 0, 
    0, 0,
  ]
}

// defines orientation of the faces (texture inside or outside)
function normalBuffer () {
  //return [1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1]
  //return [0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0,]
  //return [0,0,1]
  return [1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1]
}

// defines the shared vertices of position and uv buffer (corners have overlapping vertices which can be refenreced by index instead of defining an new verticie)
function indexBuffer () {
  /*return [
    0,  1,  2,   2,  1,  3,  // front
    4,  5,  6,   6,  5,  7,  // right
    8,  9, 10,  10,  9, 11,  // back
   12, 13, 14,  14, 13, 15,  // left
   16, 17, 18,  18, 17, 19,  // top
   20, 21, 22,  22, 21, 23,  // bottom
  ]*/
  return [0, 2, 1, 2, 3, 1, 4, 6, 5, 6, 7, 5, 8, 10, 9, 10, 11, 9, 12, 14, 13, 14, 15, 13, 16, 18, 17, 18, 19, 17, 20, 22, 21, 22, 23, 21]
}

// group the vertices belonging to each of the 6 sides, allows for 6 different textures one for each side.
function groupBuffer () {
  return [
    {
      start: 0,
      count: 6,
      materialIndex: 0
    },
    {
      start: 6,
      count: 6,
      materialIndex: 1
    },
    {
      start: 12,
      count: 6,
      materialIndex: 2
    },
    {
      start: 18,
      count: 6,
      materialIndex: 3
    },
    {
      start: 24,
      count: 6,
      materialIndex: 4
    },
    {
      start: 30,
      count: 6,
      materialIndex: 5
    }
  ]
}

export { positionBuffer, uvBuffer, normalBuffer, indexBuffer, groupBuffer }